<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5">
<h1 class="chap1d">CONTENTS</h1>
</a><h2 class="toc1"><a id="VPS-5"></a><a href="#/xhtml/006_Preface">Preface</a></h2>
<h2 class="toc_1"><a href="#/xhtml/007_Chapter_1"><span class="hang_1">Chapter 1</span>
The Ancient World</a></h2>
<h2 class="toc_1"><a href="#/xhtml/008_Chapter_2"><span class="hang_1">Chapter 2</span>
 The Early Workings</a></h2>
<h2 class="toc_1"><span href="#/xhtml/009_Chapter_3" title="Link target outside of Sample"><span class="hang_1">Chapter 3</span>
The Stannaries</span></h2>
<h2 class="toc_1"><span href="#/xhtml/010_Chapter_4" title="Link target outside of Sample"><span class="hang_1">Chapter 4</span>
 Deep Mines</span></h2>
<h2 class="toc_1"><span href="#/xhtml/011_Chapter_5" title="Link target outside of Sample"><span class="hang_1">Chapter 5</span>
Tutwork, Tribute and Dressing</span></h2>
<h2 class="toc_1"><span href="#/xhtml/012_Chapter_6" title="Link target outside of Sample"><span class="hang_1">Chapter 6</span>
Watt and the Pirates</span></h2>
<h2 class="toc_1"><span href="#/xhtml/013_Chapter_7" title="Link target outside of Sample"><span class="hang_1">Chapter 7</span>
The Health of the Miners</span></h2>
<h2 class="toc_1"><span href="#/xhtml/014_Chapter_8" title="Link target outside of Sample"><span class="hang_1">Chapter 8</span>
Home Life</span></h2>
<h2 class="toc_1"><span href="#/xhtml/015_Chapter_9" title="Link target outside of Sample"><span class="hang_1">Chapter 9</span>
 Children at Work</span></h2>
<h2 class="toc_1"><span href="#/xhtml/016_Chapter_10" title="Link target outside of Sample"><span class="hang_1">Chapter 10</span>
 Smelters and Foundries</span></h2>
<h2 class="toc_1"><span href="#/xhtml/017_Chapter_11" title="Link target outside of Sample"><span class="hang_1">Chapter 11</span>
 The Working Men</span></h2>
<h2 class="toc_1"><span href="#/xhtml/018_Chapter_12" title="Link target outside of Sample"><span class="hang_1">Chapter 12</span>
 Silver and Lead</span></h2>
<h2 class="toc_1"><span href="#/xhtml/019_Chapter_13" title="Link target outside of Sample"><span class="hang_1">Chapter 13</span>
 The Cousin Jacks</span></h2>
<h2 class="toc_1"><span href="#/xhtml/020_Chapter_14" title="Link target outside of Sample"><span class="hang_1">Chapter 14</span>
 A Changing World</span></h2>
<h2 class="toc_1"><span href="#/xhtml/021_Chapter_15" title="Link target outside of Sample"><span class="hang_1">Chapter 15</span>
 The Camborne School of Mines</span></h2>
<h2 class="toc_1"><span href="#/xhtml/022_Chapter_16" title="Link target outside of Sample"><span class="hang_1">Chapter 16</span>
 The Long Decline</span></h2>
<h2 class="toc_1"><span href="#/xhtml/023_Chapter_17" title="Link target outside of Sample"><span class="hang_1">Chapter 17</span>
 Places to Visit</span></h2>
<h2 class="toc_11"><span href="#/xhtml/024_Bibliography" title="Link target outside of Sample">Select Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?19a5beb1